module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak przyrodniczo-edukacyjny czerwony.svg?5f8f0a1b";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak przyrodniczo-edukacyjny czerwony.svg
// module id = 2024
// module chunks = 0